import { ErrorHandler, Injectable } from '@angular/core';
import rg4js from 'raygun4js';
import { environment } from './src/environments/environment';
const VERSION_NUMBER = '1.0.0.0';
const API_KEY = 'u4syG1M1FfBtgZzllFpxQ';
​
const enableRaygun = environment.raygunEnabled;
​
if (enableRaygun) {
    rg4js('apiKey', API_KEY);
    rg4js('setVersion', VERSION_NUMBER);
    rg4js('enableCrashReporting', true);
}
@Injectable()
export class RaygunErrorHandler implements ErrorHandler {
    handleError(e: any): void {
        if (enableRaygun) {
            console.error('err caught for raygun >', e);
            rg4js('send', {
                error: e,
            });
        } else {
            console.error('NON PROD ENV. ERR DETAILS >', e);
        }
    }
}
